<div *ngIf="isLoading" class="loading-container">
  <div style="width:100%; padding: 10px;">
    <ngx-skeleton-loader
      count="5"
      [theme]="{ 
        'height.px': 50
      }"
    ></ngx-skeleton-loader>
  </div>
</div>

<div *ngIf="!isLoading" class="card">
  <div 
    *ngIf="!hideTitle"
    fxLayout="row" 
    fxLayoutAlign="space-between center"
    class="header">
    <h6>{{formName}}</h6>
    <div>
      <button
          type="button"
          mat-icon-button
          appPreventDoubleClick (throttledClick)="openConfirmDeleteDialog()"
          *ngIf="!emptyForm && canDelete"
          [attr.aria-label]="'Delete' | translate: {Default: 'Delete'}"
      >
          <mat-icon
              class="material-icons-outlined delete-icon"
              aria-hidden="true"
          >delete</mat-icon>
      </button>
    </div>
  </div>

  <!-- Form div -->
  <div class="content form">

    <form [formGroup]="form"
          (ngSubmit)="onSubmit()"
    >
    <!-- We have to use ng container and individual mat-form-field because of a known error in angular material with mat-select -->
      <div class="form-container">

        <ng-container *ngFor="let field of this.formData.body">
          <ng-container *ngIf="field.type !== fieldTypes.TEXT_LOCALIZATION; else textLocalizationContainer">
          
            <div class="container-element" *ngIf="field.type === fieldTypes.CONTAINER; else formField">
              <h6>
                {{field.text}}
              </h6>

              <ng-container *ngFor="let child of field.children">
                <app-dynamic-form-field
                  [controlName]="child.formControl"
                  [field]="child"
                ></app-dynamic-form-field>
              </ng-container>
            </div>

            <ng-template #formField>
              <app-dynamic-form-field
                [controlName]="field.formControl"
                [field]="field"
              ></app-dynamic-form-field>
            </ng-template>

          </ng-container>

          <ng-template let-formArrayName="field" #textLocalizationContainer>
            <app-localization-text-form-field
                *ngIf="localizations"
                [formElement]="{ formControl: 'localizations', localizationValueParam: 'localization', text: ('WorkLocationName' | translate: {Default: 'Work location name'}), disabled: 'false' }"
                [parentGroup]="form"
                [cultures]="cultures"
                [showTitle]="false"
                (emitAddtoFormArray)="addNewLocalization()"
                (emitDeleteFromFormArray)="deleteLocalization($event.index)"
            ></app-localization-text-form-field>
          </ng-template>

        </ng-container>
      </div>
      
      <div *ngIf="!hideButtons" class="button-container">
        <button mat-raised-button appPreventDoubleClick (throttledClick)="emitCloseDialog()">Cancel</button>
        <button mat-raised-button class="submit-button" type="submit" [disabled]="(form && !form.valid) || submittingForm">Submit</button>
      </div>
    </form>
  </div>
</div>